<!-- Search Form -->
<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel header="{{'label.search' | translate }}" [toggleable]="true" [collapsed]="panelCollapsed"
      expandIcon="pi pi-angle-double-up" collapseIcon="pi pi-angle-double-down">
      <div class="card" #contentElement pBPaaSFocusTrap>
        <!-- Row 1: Corp No., Brand, Vendor Category -->
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('ouId')" class="bpaas-required">Corp No.</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="ouSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchOuSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
              formControlName="ouId" [inputId]="parseToId('ouId')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('ouId')">
              <small class="p-error" *ngIf="formControl('ouId').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('itemNumber')" class="bpaas-required">{{ 'field.item-number' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="itemSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchItemSuggestions($event)"
              (onClear)="onItemClear()" (onFocus)="autoCompleteFocus($event)" (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)" (onSelect)="onItemSelect($event)" dataKey="value" appendTo="body"
              formControlName="itemNumber" [inputId]="parseToId('itemNumber')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('itemNumber')">
              <small class="p-error" *ngIf="formControl('itemNumber').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <label [for]="parseToId('itemDesc')">{{ 'field.item-desc' | translate }}</label>
            <input type="text" pInputText formControlName="itemDesc" [id]="parseToId('itemDesc')" readonly />
          </div>
        </div>
        <!-- Row 2: Item Number, Item Desc -->
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('brand')">{{ 'field.brand' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="brandSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchBrandSuggestions($event)" (onClear)="onBrandClear()"
              (onFocus)="autoCompleteFocus($event)" (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)" (onSelect)="onBrandSelect()" dataKey="value" appendTo="body"
              formControlName="brand" [inputId]="parseToId('brand')" field="label">
            </p-autoComplete>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('vendorCategory')">
              {{ 'field.vendor-category' | translate }}
              <i *ngIf="loadingVendorCtg" class="pi pi-spin pi-spinner" style="font-size: 0.85rem; margin-left: 4px;"></i>
            </label>
            <p-dropdown *ngIf="langChangeVisible" [options]="vendorCategoryOptions" optionLabel="label"
              optionValue="value" [filter]="true" filterBy="label" [showClear]="true" appendTo="body"
              placeholder="{{ 'option.please-select' | translate }}" (onShow)="onVendorCategoryShow()"
              formControlName="vendorCategory" [inputId]="parseToId('vendorCategory')">
            </p-dropdown>
          </div>
        </div>
        <!-- Buttons -->
        <div class="grid p-fluid justify-content-end bpaas-button-row">
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.reset' | translate }}" class="p-button-outlined mr-2"
              (click)="searchReset();onItemClear();" [id]="parseToId('btnReset')"></button>
          </div>
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.query' | translate }}" (click)="query()"
              [id]="parseToId('btnQuery')"></button>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>

<!-- Total Qty -->
<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <div class="grid p-fluid">
      <div class="col-12 md:col-3 lg:col-3">
        <label>{{ 'field.total-qty' | translate }}</label>
        <input type="text" pInputText [value]="totalQty | number" readonly style="text-align: right" />
      </div>
    </div>
  </p-panel>
</div>

<!-- Query Results -->
<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <span *ngIf="queryId">{{ 'field.query-id' | translate }} : {{queryId}}</span>

    <p-table #tableComponent [value]="detailDatas" styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped"
      [selectionMode]="tableSelectionMode" [(selection)]="rowSelectedDatas" [dataKey]="rowDataKeyName"
      [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'table.paginator' | translate: {'first': '{first}', 'last': '{last}', 'totalRecords': '{totalRecords}' } }}"
      [rowsPerPageOptions]="[10, 25, 50]" [paginatorDropdownAppendTo]="'body'" scrollHeight="75vh" [scrollable]="true"
      [frozenWidth]="'600px'" [resizableColumns]="true" columnResizeMode="expand" [columns]="selectedColumns"
      [detailInViewStatus]="detailInViewStatus()" (onStateSave)="onDetailTableStateSave($event)"
      (onFilter)="onDetailTableFilter($event)" (onColResize)="onColResize($event)">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngIf="!isMobile">
            <!-- 凍結欄位 (SEQ, IR No, Status, OU, OU_Name, Line) -->
            <th *ngFor="let column of tableColumns.slice(0, 6)" pFrozenColumn
              [pSortableColumn]="column.sortable ? column.field : ''" [pSortableColumnDisabled]="!column.sortable"
              [style]="(column.width ? 'width: ' + column.width + 'px; ' : '') + 'text-align: left'">
              <label>{{ column.header | translate }}</label>
              <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
            </th>
            <!-- 可滾動欄位 -->
            <th *ngFor="let column of tableColumns.slice(6)" [pSortableColumn]="column.sortable ? column.field : ''"
              [pSortableColumnDisabled]="!column.sortable" [style]="column.width ? 'width: ' + column.width + 'px' : ''"
              pResizableColumn>
              <label>{{ column.header | translate }}</label>
              <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
            </th>
          </ng-container>
          <ng-container *ngIf="isMobile">
            <th *ngFor="let column of tableColumns" [pSortableColumn]="column.sortable ? column.field : ''"
              [pSortableColumnDisabled]="!column.sortable" pResizableColumn>
              <label>{{ column.header | translate }}</label>
              <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [id]="parseToId('rowData-' + rowIndex)">
          <ng-container *ngIf="!isMobile">
            <!-- 凍結欄位 -->
            <td *ngFor="let column of tableColumns.slice(0, 6)" pFrozenColumn
              [class.bpaas-align-right]="column.numberField || column.alignRight"
              [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
              <ng-container *ngIf="column.numberField">
                {{ (rowData[column.field] ?? 0) | dynamicDecimal }}
              </ng-container>
              <ng-container *ngIf="!column.numberField">
                {{ rowData[column.field] }}
              </ng-container>
            </td>
            <!-- 可滾動欄位 -->
            <td *ngFor="let column of tableColumns.slice(6)" [class.bpaas-align-right]="column.numberField || column.alignRight"
              [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
              <ng-container *ngIf="column.numberField">
                {{ (rowData[column.field] ?? 0) | dynamicDecimal }}
              </ng-container>
              <ng-container *ngIf="!column.numberField">
                {{ rowData[column.field] }}
              </ng-container>
            </td>
          </ng-container>
          <ng-container *ngIf="isMobile">
            <td *ngFor="let column of tableColumns" [class.bpaas-align-right]="column.numberField || column.alignRight"
              [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
              <ng-container *ngIf="column.numberField">
                {{ (rowData[column.field] ?? 0) | dynamicDecimal }}
              </ng-container>
              <ng-container *ngIf="!column.numberField">
                {{ rowData[column.field] }}
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="tableColumns.length">
            {{ 'table.no-records-found' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>
